export default __webpack_public_path__ + "static/NoContent-0af9271b12b440e5a1a3227cbcfd172f.gif";